import React, { useState, useEffect, useRef, JSX } from 'react'
import { DataGrid, Column, Export, Scrolling, FilterRow, StateStoring, Pager, Paging, HeaderFilter } from 'devextreme-react/data-grid';
import GridItem from "components/Grid/GridItem.js";
import DateBox from 'devextreme-react/date-box';
import GridContainer from "components/Grid/GridContainer.js";
import moment from 'moment'
import { CreateUrl, CallGetAPI } from 'Utils/ApiHelper.js';
import { useIntl, IntlShape, FormattedMessage } from 'react-intl';
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { locale, loadMessages } from "devextreme/localization";
import { useMobileContext, useMobileLandscape, useTabletContext } from '../../Context/ContextProvider'
import { ChariotConfig, ChariotAlarm, configFromJson, jsonFromConfig } from "models/ChariotConfig"
import { Button } from "@mui/material"
import Modal from 'react-bootstrap/Modal';
import { adjustTime } from '../../Utils/AdjustTime'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Lottie from 'lottie-react'
import rotateScreenAnimation from '../../assets/rotate-phone.json'
interface Props {
    serial: number
    model: string
}

interface Audit {
    details: string
    email: string
    serial: number 
    timeStamp: Date
    type: string
    userGuid: string
    configChanges: unknown
    id: number
}
const ConfigurationPanel: React.FC<Props> = ({ serial }) => {
    const isLandscape = useMobileLandscape()
    const isMobile = useMobileContext()
    const isTablet = useTabletContext()
    const intl = useIntl()
    const gridRef = useRef(null)
    const [startDate, setStartDate] = useState<Date>(moment().subtract(3, 'months').toDate())
    const [endDate, setEndDate] = useState<Date>(moment().toDate())
    const [gridData, setGridData] = useState<Array<Audit>>()
    const [tempAudit, setTempAudit] = useState<Audit | null>()
    const [modal, setModal] = useState<boolean>()
    locale(sessionStorage.getItem('language'));
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);


    const startDateChanged = (date): void => {
        setStartDate(date.value)

    }

    const endDateChanged = (date) => {
        setEndDate(date.value)

    }

    const reloadData = () => {

        CallGetAPI(CreateUrl(`/api/aquaguard/audit?serial=${serial}&type=CONFIG&startDate=${moment(startDate).set({ 'hour': 0, 'minute': 0, 'second': 0, 'millisecond': 0 }).format("YYYY-MM-DD HH:mm:ss")}&endDate=${moment(endDate).set({ 'hour': 23, 'minute': 59, 'second': 59, 'millisecond': 0 }).format("YYYY-MM-DD HH:mm:ss")}`), {})
            .then(data => {
                data.forEach((d, idx) => {

                    //console.log(d, idx)
                    if (idx > 0) {
                        d.daysActive = moment(data[idx-1].timeStamp).diff(moment(data[idx].timeStamp), 'days').toString()
                    } else {
                        d.daysActive = intl.formatMessage({ id: 'Currently Active'})
                    }
                    
                    d.id = idx
                    d.serial = parseInt(d.serial)
                    const jsonStringStart = (d.details.indexOf("{"))
                    if (jsonStringStart !== -1) {
                        d.configChanges = JSON.parse(d.details.slice(jsonStringStart, d.details.length))
                        d.details = d.details.slice(0, jsonStringStart)
                    } else {
                        d.configChanges = null
                    }
                })
                
                setGridData(data)
            })
    }

    const renderTimeStamp = ({ data }) => { 
       return !isMobile ?
           moment(adjustTime(data.timeStamp)).format("DD MMM YYYY HH:mm:ss") :
           moment(adjustTime(data.timeStamp)).format("DD MMM YYYY")
    }

    const renderDetailsBtn = (data, intl):JSX.Element => {
        return (
            <div style={{display: "flex", justifyContent: "center"} }>
                <Button variant="contained" disabled={!data.data.configChanges} onClick={(): void => handleDetailsClick(data.data)}>{intl.formatMessage({ id: 'Changes' })}</Button>
            </div>
        )
    }

    const toggleModal = () => {
        setModal(!modal)
    }


    const handleDetailsClick = (data: Audit): void => {
        toggleModal()
        setTempAudit(data)
    }

    useEffect(() => {
        reloadData()
    }, [startDate, endDate])

    const addUnitOrParseValue = (key: string, value: string | boolean | number): string | number | boolean => {
        

        //if key is schedule
        if (key.includes('Schedule') || key.includes('SampleTime')) {
                if (parseInt(value) >= 3600) {
                    return `${parseInt(value) / 3600} hour(s)`
                } else if (parseInt(value) >= 60) {
                    return `${parseInt(value) / 60} minutes(s)`
                } else {
                    return `${parseInt(value)} second(s)`
                }
        }
        //if key is units
        if (key.includes('Units')) {
            switch (value) {
                case "01":
                    return `Litres`
                case "02":
                    return 'Meters cubed (m3)'
                case "03":
                    return 'Bar'
                case "04":
                    return 'Millibar'
                case "05":
                    return 'Meters Head (mH2O)'
                case "06":
                    return 'psi'
                case "07":
                    return 'US Gallons (gal)'
                case "08":
                    return 'Foot3'
                case "09":
                    return 'Litres/sec (l/s)'
                case "10":
                    return 'Mitres cubed /hour (m3/h)'
                case "11":
                    return 'Mega Litres per Day (Ml/d)'
                case "12":
                    return 'Kilopascals (kPa)'
                case "13":
                    return 'Feet Head (ftH2O)'
            }
           
        }

        if (key.includes('PulseType')) {
            switch (value) {
                case 0:
                    return 'Inactive'
                case 1: 
                    return 'Forward'
                case 2:
                    return 'Forward/Reverse'   
                case 3:
                    return 'Forward/Direction'
                case 17: 
                    return 'Forward (PIT)'
                case 18:
                    return 'Forward/Reverse (PIT)'
                case 20:
                    return 'Digital'
            }
        }

        if (key.includes('SampleType')) {
            return value ? 'on' : 'off'
        }

        
      


        if (value === true) {
            return 'on'
        } else if (value === false) {
            return 'off'
        }

        if (typeof(value) === 'number') {
            return value.toString()
        }

        else return value
    } 

    const renderChanges = (): JSX.Element => {
        const detailsListOriginal = []
        const detailsList = []
        const outputArr = []
        const keys = []
        const email = tempAudit?.email
        
        console.log(tempAudit, gridData)
        let nextConfigTimestamp = null
        if (tempAudit?.id !== 0 && gridData) {
            nextConfigTimestamp = gridData[gridData?.findIndex(d => d.id === tempAudit.id) - 1].timeStamp
        }
        console.log(nextConfigTimestamp)
        for (const key in tempAudit?.configChanges) {
            if (key.includes('Original')) {
                const original = addUnitOrParseValue(key, tempAudit.configChanges[key])
                if (key.includes('MapMin') || key.includes('MapMax')) {
                    detailsListOriginal.push(`${original} ${addUnitOrParseValue('Units', tempAudit.configChanges[key.slice(0,9) + 'Units'])}`)
                } else {
                    detailsListOriginal.push(original)
                }
            } else {
                keys.push(key)
                const change = addUnitOrParseValue(key, tempAudit.configChanges[key])
                if (key.includes('MapMin') || key.includes('MapMax')) {
                    detailsList.push(`${change} ${addUnitOrParseValue('Units', tempAudit.configChanges[key.slice(0, 9) + 'Units'])}`)
                } else {
                    detailsList.push(change)
                }
            }
        }
        for (let i = 0; i < detailsList.length; i++) {
            if (detailsListOriginal[i]) {
                outputArr.push({
                    key: keys[i],
                    original: detailsListOriginal[i],
                    change: detailsList[i],
                    email: email,
                    activeFor: tempAudit && tempAudit.id !== 0 && nextConfigTimestamp ? `${moment(nextConfigTimestamp).diff(moment(tempAudit.timeStamp), 'days')} days` : 'Active Now'
                })
            }
        }
        console.log(outputArr)
        return (
            <DataGrid
                dataSource={outputArr}
                onExporting={(e):void => onExporting(e)}
                export={{ enabled: true }}

            >
                <Scrolling mode="standard" useNative={true} />
                <FilterRow visible={true} />
                <HeaderFilter visible={true} />
                <Column dataField="key" caption={intl.formatMessage({ id: "Configuration Element" })} cellRender={(data) => renderModalKey(data)} />
                <Column dataField="original" caption={intl.formatMessage({id: "Previous State/Value"}) } />
                <Column dataField="change" caption={intl.formatMessage({ id: "New State/Value" })} />
                <Column dataField='activeFor' caption={intl.formatMessage({id: "Active For"}) } dataType="string" />

                {isMobile && isLandscape && <Column dataField="email" caption={intl.formatMessage({ id: "Changed By" })} />}
            </DataGrid>
        )
    }


    const renderModalKey = ({ data }):string => {
        if (data.key.includes('SampleType')) {
            return `${data.key.slice(0, 9)} Min/Max Sampling`
        } 
        if (data.key.includes('MapMin')) {
            return `${data.key.slice(0, 9)} Current Min Value` 
        }
        if (data.key.includes('MapMax')) {
            return `${data.key.slice(0, 9)} Current Max Value`
        }
        return data.key
    }

    const translateDetails = (data: any, intl: IntlShape):React.ReactNode => {
        return intl.formatMessage({ id: data.data.details })
    }


    const onExporting = (e: any): void => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Readings');

        exportDataGrid({
            component: e.component,
        worksheet: worksheet
    }).then(function () {
        workbook.xlsx.writeBuffer()
            .then(function (buffer: Buffer) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), window.location.hostname.includes('zonelog.net') ? 'ZONELOG Export.xlsx' : 'Aquaguard Export.xlsx');
            });
    });
    e.cancel = true;
}

    return (<div style={{position: "relative"} }>
        <Modal show={modal}
            style={{marginTop: isLandscape ? 30 : 100} }
        >
            <Modal.Header>
                <Modal.Title><FormattedMessage id='Config Changes' /></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {tempAudit && renderChanges()}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="contained" color="error" onClick={(): void => toggleModal()}><FormattedMessage id='Close' /></Button>
            </Modal.Footer>
        </Modal>
        <GridContainer>
            <GridItem xs={12} sm={6} md={5}>
                <div style={{margin: "10px 0 0 25px"} }>
                    <FormattedMessage id="Start date" /> :&nbsp;<DateBox id="startDate" displayFormat={"dd/MM/yyyy"} value={startDate} onValueChanged={startDateChanged} />
                </div>
            </GridItem>
            <GridItem xs={12} sm={6} md={5}>
                <div style={{ margin: "10px 0 0 25px" }}>
            <FormattedMessage id="End date" /> :&nbsp;<DateBox id="endDate" displayFormat={"dd/MM/yyyy"} value={endDate} onValueChanged={endDateChanged} />
            </div>
            </GridItem>
            {isMobile && !isLandscape && <GridItem xs={12} sm={6} md={5}>
                <div style={{display: 'flex', justifyContent: 'center', width: '100%'} }>
                    <div style={{ margin: "10px 0 0 25px", display: 'flex', justifyContent: 'space-between', width: '80%' }}>
                        <p style={{ margin: '6px 0 0 0' }}>{intl.formatMessage({ id: 'For more information rotate your phone' })}</p>
                        <Lottie animationData={rotateScreenAnimation} loop={true} style={{ width: "10%" }} />
                    </div>
                </div>
            </GridItem>}
            <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", width: "100%", marginLeft: isMobile ? '25px' : 0 } }>
                <DataGrid
                    ref={gridRef}
                    dataSource={gridData}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    columnMinWidth={!isMobile ? 80 : 0}
                    width={!isMobile || isLandscape ? 'inherit' : 310 }
                    //onExporting={this.onExporting} >
                    style={{
                        border: isMobile ? '1px solid gray' : 'none',
                    }}
                >
                    <Scrolling mode="standard" useNative={true} />
                    <FilterRow visible={true} />
                    <HeaderFilter visible={true} />
                    {(!isMobile || isLandscape) && <Column dataField="email" dataType="string" caption={intl.formatMessage({ id: "Updated By" })} />}
                    <Column dataField="details" width={isMobile ? 100 : 'inherit'} dataType="string" caption={intl.formatMessage({ id: "Details" })} cellRender={(data):React.ReactNode => translateDetails(data, intl)} />
                    <Column width={isMobile ? 100 : 'inherit'} dataField="timeStamp" dataType="datetime" cellRender={renderTimeStamp} caption={intl.formatMessage({ id: "TimeStamp" })} />
                    <Column dataField='daysActive' dataType='string' />
                    <Column width={isMobile ? 100 : 'inherit'} cellRender={(data): JSX.Element => renderDetailsBtn(data, intl)} />
                </DataGrid>
            </div>
        </GridContainer>
    </div>)
}

export default ConfigurationPanel